import React, { useEffect } from 'react';
import { useToolbarPosition } from './useToolbarPosition';

const useAppendToolbar = (elToolbarRef: React.RefObject<HTMLElement>) => {
  const initPosition = useToolbarPosition();

  // Function to append Toolbar to the correct container based on position
  const doAppendToolbar = (position: string) => {
    const shadow = document.getElementById('contensis-blocks-preview-toolbar');
    if (shadow) {
      const root = shadow.shadowRoot;

      if (root) {
        // Position is the containers id
        const container = root.getElementById(position);

        if (container && elToolbarRef.current) {
          const toolbarElement = elToolbarRef.current;

          // Remove from the current container (if any)
          const currentContainer = toolbarElement.parentElement;
          if (currentContainer) {
            currentContainer.removeChild(toolbarElement);
          }

          // Append to the new container
          container.appendChild(toolbarElement);
        }
      }
    }
  };

  useEffect(() => {
    if (elToolbarRef?.current) {
      if (initPosition) doAppendToolbar(initPosition);
    }
  }, [initPosition, elToolbarRef]);

  return { initPosition };
};

export default useAppendToolbar;
